import { db } from "@/firebase"

const dates_ref = db.collection("projects_dates_configs")

async function getDates() {
    let dates_list = []
    try {
        const datesRef = await dates_ref.where("deletedAt","==",null).get()
        datesRef.forEach((doc) => dates_list.push({ ...doc.data(), id_doc: doc.id }));
        return dates_list
    } catch (error) {
        console.error(error)
        throw error;
    }
}

async function getAverageDates() {
    let dates_list = []
    try {
        const datesRef = await dates_ref.where("deletedAt","==",null).get()
        datesRef.forEach((doc) => {
            const data = doc.data()
            dates_list.push({
                text: data.name,
                value: `${data.minDate} a ${data.maxDate}`,
                id_doc: doc.id
            })
        });
        return dates_list
    } catch (error) {
        console.error(error)
        throw error;
    }
}

const createDate = async (data) => {
    try {
        const get_data = await dates_ref.add(data);
        await editDate(get_data.id, { ...data, id_doc: get_data.id })
        return get_data.id;
    } catch (error) {
        throw new Error("createDate Fail!" + error.message)
    }
}

const editDate = async (idDoc, data) => {
    try {
        await dates_ref.doc(idDoc).update(data);
        return true;
    } catch (error) {
        throw new Error("editDate Fail!" + error.message)
    }
}

export default {
    createDate,
    getDates,
    editDate,
    getAverageDates
};